import React from "react"
import { withStyles } from "@material-ui/core/styles"
import Card from "@material-ui/core/Card"
import CardContent from "@material-ui/core/CardContent"
import Typography from "@material-ui/core/Typography"
import { StaticGoogleMap, Marker } from "react-static-google-map"
import Cancel from "@material-ui/icons/Cancel"
import pink from "@material-ui/core/colors/pink"

const styles = theme => ({
  card: {
    maxWidth: 150,
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
    position: "relative",
    "&:hover $removeIconWrapper": {
      opacity: 1,
    },
  },
  cardContent: {
    padding: [theme.spacing(1), "!important"],
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
  },
  mapImage: {
    verticalAlign: "middle",
  },
  cityName: {
    fontSize: "0.9em",
    fontWeight: 600,
  },
  distance: {
    color: "rgba(0, 0, 0, 0.37)",
    fontSize: "0.9rem",
    fontWeight: 600,
    lineHeight: "1.1em",
  },
  removeIconWrapper: {
    top: "5px",
    right: "5px",
    position: "absolute",
    cursor: "pointer",
    opacity: 0,
    transition: theme.transitions.create("opacity", {
      duration: theme.transitions.duration.enteringScreen,
    }),
    "&:after": {
      content: "''",
      backgroundColor: pink["A200"],
      height: "20px",
      width: "20px",
      position: "absolute",
      top: "4px",
      right: "4px",
      borderRadius: "50%",
      display: "block",
      zIndex: "0",
    },
  },
  removeIcon: {
    color: "#fff",
    width: "1.2em",
    height: "1.2em",
    position: "relative",
    zIndex: 1,
  },
})

const MapCard = ({ classes, location, canRemove, onRemove }) => (
  <Card className={classes.card}>
    {canRemove && (
      <div className={classes.removeIconWrapper}>
        <Cancel onClick={onRemove} className={classes.removeIcon} />
      </div>
    )}
    <div className={classes.cardMap}>
      <StaticGoogleMap
        className={classes.mapImage}
        size="150x150"
        center={`${location.lat},${location.lon}`}
        zoom="13"
        apiKey="AIzaSyBH1JVqWhWjVFovOypE3kxxHx4GmPnPDUY"
      >
        <Marker location={`${location.lat},${location.lon}`} />
      </StaticGoogleMap>
    </div>
    <CardContent className={classes.cardContent}>
      <Typography
        className={classes.cityName}
        gutterBottom
        variant="h6"
        component="h2"
      >
        {location.label}
      </Typography>
      <Typography variant="subtitle1" component="p">
        {location.work_radius}mi
      </Typography>
    </CardContent>
  </Card>
)

export default withStyles(styles, { withTheme: true })(MapCard)
